import { useState } from 'react'

import type {
  OrganizationInvitation,
  OrganizationMember,
} from '@/components/org-settings/members/members.interface'

import { useMembersDialogHandlers } from './use-members-dialog-handlers.hook'

interface ViewStateData {
  memberList: OrganizationMember[]
  invitationList: OrganizationInvitation[]
}

export const useMembersViewState = ({ memberList, invitationList }: ViewStateData) => {
  const [isInviteDialogOpen, setIsInviteDialogOpen] = useState(false)
  const [memberToRemoveId, setMemberToRemoveId] = useState<string | null>(null)
  const [invitationToRevokeId, setInvitationToRevokeId] = useState<string | null>(null)
  const [isLeaveDialogOpen, setIsLeaveDialogOpen] = useState(false)

  const handlers = useMembersDialogHandlers({
    memberToRemoveId,
    invitationToRevokeId,
    setIsInviteDialogOpen,
    setMemberToRemoveId,
    setInvitationToRevokeId,
    setIsLeaveDialogOpen,
  })

  return {
    isInviteDialogOpen,
    setIsInviteDialogOpen,
    memberToRemove: memberList.find((m) => m.id === memberToRemoveId) ?? null,
    setMemberToRemoveId,
    invitationToRevoke: invitationList.find((i) => i.id === invitationToRevokeId) ?? null,
    setInvitationToRevokeId,
    isLeaveDialogOpen,
    setIsLeaveDialogOpen,
    ...handlers,
  }
}
